import React from "react";

export function FlexDividerHorizontal() {
  return <div className="flex-1 h-px bg-zinc-800"></div>;
}
